import React from 'react';
import { openCreateSaveViewModal } from 'app/components/SavedViews/saveViewModalBridge';
import { useSavedViewsSlice } from 'app/components/SavedViews';
import styles from './ShareViewButton.module.scss';

interface SaveViewButtonProps {
  label?: string;
}

export const SaveViewButton: React.FC<SaveViewButtonProps> = ({
  label = 'Save View'
}) => {
  useSavedViewsSlice();

  return (
    <button
      onClick={() => openCreateSaveViewModal()}
      className={styles.saveViewButton}
      aria-label={label}
      type="button"
      data-testid="save-view-button"
    >
      {label}
    </button>
  );
};
